import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "app/contexts/auth";
import {
  Container,
  Grid,
  LinearProgress,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const initialState = {
  username: "",
  password: "",
};

export function LoginForm() {
  const location = useLocation();
  const auth = useAuthContext();

  const [state, setState] = useState(initialState);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      return auth.login({ user: state });
    } catch (error) {
      console.log("error");
    }
  }

  if (!!auth.isAuthenticated) {
    console.log(location);

    return <Navigate to={location.state?.redirectTo || "/"} />;
  }

  return (
    <Container maxWidth="xs">
      <Paper>
        {!!auth.isLogging && <LinearProgress />}

        <Stack alignItems="center" spacing={2} padding={2}>
          <img
            src="/static/images/ccia-color-logo-transparent.png"
            alt="ccia-color-logo-transparent.png"
            style={{ width: "40%" }}
          />

          <Typography variant="h6">Iniciar sesión</Typography>

          <Grid
            container
            rowSpacing={2}
            component="form"
            onSubmit={handleSubmit}
          >
            <Grid item xs={12}>
              <TextField
                type="text"
                label="Usuario"
                value={state.username}
                onChange={(e) =>
                  setState((state) => ({
                    ...state,
                    username: e.target.value.trim(),
                  }))
                }
                fullWidth
                required
                autoFocus
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                type="password"
                label="Contraseña"
                value={state.password}
                onChange={(e) =>
                  setState((state) => ({ ...state, password: e.target.value }))
                }
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12}>
              <LoadingButton
                type="submit"
                variant="contained"
                loading={auth.isLogging}
                loadingIndicator="Accediendo..."
                fullWidth
              >
                Acceder
              </LoadingButton>
            </Grid>
          </Grid>
        </Stack>
      </Paper>
    </Container>
  );
}
